import component from '../component';

export default component('MuiLink', {
  defaultProps: {
    underline: 'none',
  },
});
